import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=6b3cabf9&"
import script from "./RegistrationCard.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports